<!-- eslint-disable -->

<template>
  <div class="container container--large">
    <!-- selected names dialog -->
    <md-dialog :md-active.sync="showDialogName">
      <!-- <md-dialog-title>Preferences</md-dialog-title> -->
      <md-content>
        <div id="promotions" class="popup">
          <div class="popup__head">
            <h5>Selected Names : {{ selNames.length }}</h5>

            <a
              @click="showDialogName = false"
              class="popup-modal-dismiss btn-close"
            >
              <i class="far fa-times" style="color: black"></i>
            </a>
          </div>
          <!-- /.popup__head -->

          <div class="popup__content popup-names">
            <div
              v-for="(item, index) in selNames"
              :key="item.id"
              class="promo-wrap-wide"
            >
              {{ index + 1 }}. {{ item.lastName
              }}{{ item.firstName ? `, ${item.firstName}` : "" }}
              <span v-if="item.sFirstName">&</span> {{ item.sFirstName }}
              <span v-if="item.lastName !== item.sLastName">{{
                item.sLastName
              }}</span>
            </div>
            <!-- /.list-checks -->
          </div>
          <!-- /.popup__content -->
        </div>
      </md-content>

      <md-dialog-actions style="border-top: 1px solid #f0f0f0">
        <md-button class="md-primary btn-grey" @click="showDialogName = false"
          >Close</md-button
        >
      </md-dialog-actions>
    </md-dialog>
    <!-- promotions dialog -->
    <md-dialog :md-active.sync="showDialog">
      <!-- <md-dialog-title>Preferences</md-dialog-title> -->
      <md-content>
        <div id="promotions" class="popup">
          <div class="popup__head" v-if="promotions.length">
            <h5 v-if="settings[0].promotionBtnDisplayText">
              {{ settings[0].promotionBtnDisplayText }}
            </h5>
            <h5 v-if="!settings[0].promotionBtnDisplayText">Promotions</h5>

            <a
              @click="showDialog = false"
              class="popup-modal-dismiss btn-close"
            >
              <i class="far fa-times" style="color: #000"></i>
            </a>
          </div>
          <!-- /.popup__head -->

          <div class="popup__content">
            <div v-for="item in promotions" :key="item.id" class="promo-wrap">
              <!-- <md-checkbox v-model="item.value" :disabled="item.paid">{{item.displayText}}{{item.allCategories}}//{{item.joinCategories}}//{{item.category}}</md-checkbox> -->
              <md-checkbox
                v-model="item.value"
                :disabled="item.paid || item.disabled"
                @change="onPromoChange(item)"
                >{{ item.displayText }}</md-checkbox
              >
            </div>
            <!-- /.list-checks -->
          </div>
          <!-- /.popup__content -->
        </div>
      </md-content>

      <md-dialog-actions>
        <md-button class="md-primary btn-grey" @click="showDialog = false"
          >Cancel</md-button
        >
        <md-button
          class="md-primary btn-green"
          @click="
            showDialog = false;
            savePromotionsCheck(promotions);
          "
          >Save</md-button
        >
      </md-dialog-actions>
    </md-dialog>

    <section class="section-web">
      <div class="section__actions d-lg-flex justify-content-between d-none">
        <div class="filters d-flex align-items-center">
          <div class="filters__content d-flex align-items-center">
            <div class="filter d-flex align-items-center">
              <label for="category">Select Category/List</label>
              <div class="select">
                <select
                  id="category"
                  v-model="selCategory"
                  @change="onCategoryChange(selCategory)"
                >
                  <option value="1">All</option>
                  <option
                    v-for="item in categories"
                    :key="item.categoryId"
                    :value="item.categoryId"
                    @change="() => {}"
                  >
                    {{ item.category }}
                  </option>
                </select>
              </div>
            </div>
            <!-- /.filter -->

            <div
              class="filter d-flex align-items-center"
              v-if="settings[0].displayLastYearsOrders"
            >
              <label for="people">Order History</label>

              <div class="select">
                <select id="people" v-model="selFilter">
                  <option
                    v-for="item in filterOptions"
                    :value="item.value"
                    :key="item.value"
                  >
                    {{ item.Label }}
                  </option>
                </select>
              </div>
              <!-- /.select -->
            </div>
            <!-- /.filter -->
          </div>
          <!-- /.filters__content -->

          <div class="filters__actions">
            <a
              @click="openPromotions()"
              class="btn btn--filter btn--pink popup-modal"
              v-if="promotions.length && settings[0].displayPromotions"
            >
              <span v-if="settings[0].promotionBtnDisplayText"
                >{{ settings[0].promotionBtnDisplayText }}
                <span v-if="promoNumber.length > 0">
                  ({{ promoNumber.length }})</span
                ></span
              >
              <span v-if="!settings[0].promotionBtnDisplayText"
                >Promotions
                <span v-if="promoNumber.length > 0">
                  ({{ promoNumber.length }})</span
                ></span
              >
            </a>
          </div>
          <!-- /.filters__actions -->
        </div>
        <!-- /.filters -->

        <div class="section__note d-flex align-items-center">
          <span>{{ selNumber.length }}</span>

          <p>
            <a
              @click="openSelectedNames(filteredData)"
              class="name-a"
              style="color: #3359d7 !important"
              title="View Selected Names"
              >Names Selected</a
            >
          </p>
          <!-- <i class="fad fa-eye"></i> -->
        </div>
        <!-- /.section__note -->
      </div>
      <!-- /.section__actions -->
      <!-- promotions MOBILE -->
      <div class="section__accordion d-block d-lg-none">
        <div class="accordion" id="accordionExample">
          <div class="card" v-if="promotions.length">
            <div class="card__head" id="headingOne">
              <h5>
                <button
                  class="card__button"
                  type="button"
                  data-toggle="collapse"
                  @click="showPromotionsMobile = !showPromotionsMobile"
                  aria-expanded="false"
                  aria-controls="collapseOne"
                >
                  <span v-if="settings[0].promotionBtnDisplayText"
                    >{{ settings[0].promotionBtnDisplayText }}
                    <span v-if="promoNumber.length > 0"
                      >({{ promoNumber.length }})</span
                    ></span
                  >
                  <span v-if="!settings[0].promotionBtnDisplayText"
                    >Promotions
                    <span v-if="promoNumber.length > 0"
                      >({{ promoNumber.length }})</span
                    ></span
                  >

                  <i class="fas fa-caret-down" style="color: #5ea6f1"></i>
                </button>
              </h5>
            </div>
            <!-- /.card__head -->

            <div
              v-if="showPromotionsMobile"
              class="card__inner"
              aria-labelledby="headingOne"
            >
              <div class="card__body">
                <ul class="list-checks-mobile">
                  <li v-for="item in promotions" :key="item.id">
                    <md-checkbox
                      v-model="item.value"
                      :disabled="item.paid"
                      @change="onPromoChange(item)"
                      >{{ item.displayText }}</md-checkbox
                    >
                  </li>

                  <li style="padding: 0">
                    <md-button
                      class="md-primary btn-grey"
                      @click="showPromotionsMobile = false"
                      style="width: 96%"
                      >Cancel</md-button
                    >
                  </li>
                  <li style="padding: 0">
                    <md-button
                      class="md-primary btn-green"
                      @click="
                        showPromotionsMobile = false;
                        savePromotionsCheck(promotions);
                      "
                      style="width: 96%"
                      >Save</md-button
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /.card -->
        </div>
        <!-- /.accordion -->
      </div>
      <!-- /.section__accordion -->

      <div class="section__content">
        <div class="boxes">
          <div
            class="
              boxes__head
              d-lg-flex
              justify-content-between
              align-items-center
              d-none
            "
          >
            <div class="boxes__checkbox d-flex align-items-center">
              <div
                class="custom-control-check"
                v-if="organizationInfo.sCheckall"
              >
                <md-checkbox
                  v-model="checkAll"
                  class="md-primary cust-check"
                  @change="checkAllPpl()"
                  >Check/Uncheck All</md-checkbox
                >
              </div>
              <div
                class="custom-control-check"
                v-if="organizationInfo.sReciprocity"
              >
                <md-checkbox
                  :disabled="!selNumber.length && !selNumberPaid.length"
                  v-model="profile[0].reciprocity"
                  class="md-primary cust-check"
                  @change="selRecip()"
                  v-if="organizationInfo.id !== 647"
                  >Reciprocity
                  <i class="fas fa-question-circle">
                    <md-tooltip md-direction="right" class="info-tooltip">
                      <span v-if="!selNumber.length && !selNumberPaid.length"
                        >Reciprocity only orders can't be processed. Please
                        choose at least 1 name from the list in order to select
                        reciprocity</span
                      >
                      <span v-if="selNumber.length || selNumberPaid.length"
                        >The reciprocity function enables you to automatically
                        send {{ $gift_word }} to people that are sending to you.
                        This is a great tool to ensure that you don’t
                        inadvertently miss someone and that everyone that sends
                        to you, gets a {{ $gift_word }} from you in return.
                        Please DO NOT rely on this alone—if everyone just
                        chooses reciprocity, and doesn’t select any recipients,
                        no one will get any {{ $gift_word }}!</span
                      >
                    </md-tooltip></i
                  >
                </md-checkbox>
                <!-- Brookline  Custom-->
                <md-checkbox
                  :disabled="
                    (!selNumber.length && !selNumberPaid.length) ||
                      selAmount < 100
                  "
                  v-model="profile[0].reciprocity"
                  class="md-primary cust-check"
                  @change="selRecip()"
                  v-if="organizationInfo.id == 647"
                  >Reciprocity
                  <i class="fas fa-question-circle">
                    <md-tooltip md-direction="right" class="info-tooltip">
                      <span
                        v-if="
                          (!selNumber.length && !selNumberPaid.length) ||
                            selAmount < 100
                        "
                        >Reciprocity is only available if you spend $100 or more
                        on names.</span
                      >
                      <span v-if="selAmount >= 100"
                        >The reciprocity function enables you to automatically
                        send {{ $gift_word }} to people that are sending to you.
                        This is a great tool to ensure that you don’t
                        inadvertently miss someone and that everyone that sends
                        to you, gets a {{ $gift_word }} from you in return.
                        Please DO NOT rely on this alone—if everyone just
                        chooses reciprocity, and doesn’t select any recipients,
                        no one will get any {{ $gift_word }}!</span
                      >
                    </md-tooltip></i
                  >
                </md-checkbox>
              </div>
              <div class="custom-control-check">
                <md-checkbox v-model="hidePaid" class="md-primary cust-check"
                  >Hide Paid Orders</md-checkbox
                >
              </div>
            </div>
            <!-- /.boxes__checkbox -->

            <div class="boxes__aside d-flex align-items-center">
              <div class="filters">
                <div class="filter filter--small d-flex align-items-center">
                  <label for="sort-1">Sort by</label>

                  <div class="select select--small">
                    <select
                      id="sort-1"
                      v-model="sortOrder"
                      @change="sortData(filteredData, 'Name', sortOrder)"
                    >
                      <option
                        v-for="item in sortOptions"
                        :value="item.value"
                        :key="item.value"
                      >
                        {{ item.Label }}
                      </option>
                    </select>
                  </div>
                  <!-- /.select -->
                </div>
                <!-- /.filter -->
              </div>
              <!-- /.filters -->

              <div class="search">
                <!-- <form action="?" method="get">
                  <label for="q" class="hidden">Search</label>
                  <input
                    type="text"
                    name="q"
                    id="q"
                    placeholder="Search names... "
                    class="search__field"
                    v-model="search"
                  />
                    </form> -->
                <md-field md-clearable>
                  <md-input
                    v-model="search"
                    placeholder="Search names ..."
                  ></md-input>
                </md-field>
                <!-- <span class="search__btn">
                    <i class="ico-search"></i>
                  </span> -->
              </div>
              <!-- /.search -->
            </div>
            <!-- /.boxes__aside -->
          </div>
          <!-- /.boxes__head -->
          <!-- MOBILE CATEGORIES -->
          <div class="boxes__outer d-block d-lg-none">
            <p>Select Category and Order History</p>

            <div class="boxes__head">
              <ul class="list-tags">
                <li>
                  <md-button
                    class="btn-grey-small"
                    @click="
                      selCategory = 1;
                      onCategoryChange(selCategory);
                    "
                    v-bind:class="{
                      'btn-blue-small': Number(selCategory) === 1,
                    }"
                    >Show All</md-button
                  >
                </li>

                <li v-for="item in categories" :key="item.categoryId">
                  <md-button
                    class="btn-grey-small"
                    @click="
                      selCategory = item.categoryId;
                      onCategoryChange(selCategory);
                    "
                    v-bind:class="{
                      'btn-blue-small':
                        Number(item.categoryId) === Number(selCategory),
                    }"
                    >{{ item.category }}</md-button
                  >
                </li>
              </ul>

              <!-- /.list-tags -->

              <!-- FILTERS MOBILE   -->
              <ul
                class="list-tags list-tags--grey"
                v-if="settings[0].displayLastYearsOrders"
              >
                <li v-for="item in filterOptions" :key="item.value">
                  <md-button
                    class="btn-grey-small"
                    @click="selFilter = item.value"
                    v-bind:class="{
                      'btn-green-small': selFilter === item.value,
                    }"
                    >{{ item.Label }}</md-button
                  >
                </li>
              </ul>
              <!-- /.list-tags -->
            </div>
            <!-- /.boxes__head -->
          </div>
          <!-- /.boxes__outer -->

          <div class="boxes__outer d-block d-lg-none">
            <div
              class="
                boxes__head
                d-flex
                justify-content-between
                align-items-center
                flex-wrap
              "
            >
              <div class="filters">
                <div class="filter filter--small d-flex align-items-center">
                  <label for="sort-2">Sort by</label>

                  <div class="select select--small">
                    <select
                      id="sort-1"
                      v-model="sortOrder"
                      @change="sortData(filteredData, 'Name', sortOrder)"
                    >
                      <option
                        v-for="item in sortOptions"
                        :value="item.value"
                        :key="item.value"
                      >
                        {{ item.Label }}
                      </option>
                    </select>
                  </div>
                  <!-- /.select -->
                </div>
                <!-- /.filter -->
              </div>
              <!-- /.filters -->

              <div class="search">
                <form action="?" method="get">
                  <button type="submit" class="search__btn">
                    <i class="ico-search"></i>
                  </button>
                </form>
              </div>
              <!-- /.search -->

              <div class="boxes__note d-flex align-items-center">
                <span>{{ selNumber.length }}</span>

                <p style="text-align: left">
                  <a
                    @click="openSelectedNames(filteredData)"
                    style="color: #3359d7 !important"
                    title="View Selected Names"
                    >Names <br />Selected</a
                  >
                </p>
              </div>
              <!-- /.section__note -->
            </div>
            <!-- /.boxes__head -->
          </div>
          <!-- /.boxes__outer -->
          <!-- MOBILE -->
          <div
            class="boxes__actions mt-2 d-flex justify-content-between d-lg-none"
          >
            <ul
              class="list-buttons list-buttons--no-border list-buttons--small"
            >
              <li>
                <md-checkbox
                  v-model="checkAll"
                  class="md-primary cust-check"
                  @change="checkAllPpl()"
                  >Check/Uncheck All</md-checkbox
                >
              </li>

              <li>
                <md-checkbox
                  :disabled="!selNumber.length && !selNumberPaid.length"
                  v-model="profile[0].reciprocity"
                  class="md-primary cust-check"
                  @change="selRecip()"
                  v-if="
                    organizationInfo.id !== 647 && organizationInfo.sReciprocity
                  "
                  >Reciprocity
                  <i class="fas fa-question-circle">
                    <md-tooltip md-direction="right" class="info-tooltip">
                      <span v-if="!selNumber.length && !selNumberPaid.length"
                        >Reciprocity only orders can't be processed. Please
                        choose at least 1 name from the list in order to select
                        reciprocity</span
                      >
                      <span v-if="selNumber.length || selNumberPaid.length"
                        >The reciprocity function enables you to automatically
                        send {{ $gift_word }} to people that are sending to you.
                        This is a great tool to ensure that you don’t
                        inadvertently miss someone and that everyone that sends
                        to you, gets a {{ $gift_word }} from you in return.
                        Please DO NOT rely on this alone—if everyone just
                        chooses reciprocity, and doesn’t select any recipients,
                        no one will get any {{ $gift_word }}!</span
                      >
                    </md-tooltip></i
                  >
                </md-checkbox>
                <!-- Brookline  Custom-->
                <md-checkbox
                  :disabled="
                    (!selNumber.length && !selNumberPaid.length) ||
                      selAmount < 100
                  "
                  v-model="profile[0].reciprocity"
                  class="md-primary cust-check"
                  @change="selRecip()"
                  v-if="organizationInfo.id == 647"
                  >Reciprocity {{ selAmount }}
                  <i class="fas fa-question-circle">
                    <md-tooltip md-direction="right" class="info-tooltip">
                      <span
                        v-if="
                          (!selNumber.length && !selNumberPaid.length) ||
                            selAmount < 100
                        "
                        >Reciprocity is only available if you spend $100 or more
                        on names.</span
                      >
                      <span v-if="selAmount >= 100"
                        >The reciprocity function enables you to automatically
                        send {{ $gift_word }} to people that are sending to you.
                        This is a great tool to ensure that you don’t
                        inadvertently miss someone and that everyone that sends
                        to you, gets a {{ $gift_word }} from you in return.
                        Please DO NOT rely on this alone—if everyone just
                        chooses reciprocity, and doesn’t select any recipients,
                        no one will get any {{ $gift_word }}!</span
                      >
                    </md-tooltip></i
                  >
                </md-checkbox>
              </li>
            </ul>
            <!-- /.list-buttons -->
          </div>
          <!-- /.boxes__actions -->

          <div class="boxes__content">
            <div class="row">
              <div
                class="col-lg-3 mb-2"
                v-for="item in filteredData"
                :key="item.id"
                v-bind:class="{ 'custom-mb2': organizationInfo.id == 647 }"
              >
                <!-- v-bind:class="{'custom-checkbox--green':item.iSentLastYear && item.reciprocal !== 'Yes','custom-checkbox--blue':item.sentToMeLastYear && item.reciprocal !== 'Yes', 'custom-checkbox--yellow':item.reciprocal === 'Yes'  }" -->

                <!-- class="
                    custom-control custom-checkbox custom-checkbox--large
                    list
                  "
                  v-bind:class="{
                    'custom-checkbox--green':
                      (item.iSentLastYear && item.reciprocal !== 'Yes') ||
                      (item.sentToMeLastYear &&
                        item.iSentLastYear &&
                        item.reciprocal !== 'Yes'),
                    'custom-checkbox--blue':
                      item.sentToMeLastYear &&
                      item.reciprocal !== 'Yes' &&
                      !item.iSentLastYear,
                    'custom-checkbox--yellow': item.reciprocal === 'Yes',
                    'custom-column': item.basketType,
                    'custom-checkbox-grey': !settings[0].displayLastYearsOrders,
                  }" -->
                <div
                  class="
                    custom-control custom-checkbox custom-checkbox--large
                    list
                  "
                >
                  <div class="custom-checkbox--all">
                    <div
                      :class="{
                        'custom-checkbox--green': item.iSentLastYear,
                      }"
                    />
                    <div
                      :class="{
                        'custom-checkbox--blue': item.sentToMeLastYear,
                      }"
                    />
                    <div
                      :class="{
                        'custom-checkbox--yellow': item.reciprocal === 'Yes',
                      }"
                    />
                  </div>
                  <!-- <label class="container" v-bind:for="item.id">{{item.lastName}} {{item.firstName}} & {{item.sLastName}} {{item.sFirstName}}
  <input type="checkbox" v-model="item.selected" class="md-primary md-custom-paid" :disabled="item.paid" v-bind:id="item.id" @click="updateStoreList(item)">
  <span class="checkmark"></span>
</label> -->
                  <input
                    v-if="organizationInfo.id != 647"
                    type="checkbox"
                    v-model="item.selected"
                    class="md-primary md-custom-paid"
                    :disabled="item.paid"
                    v-bind:id="item.id"
                    @change="listChanged()"
                  />
                  <!-- for all organization without customization -->
                  <label
                    v-bind:for="item.id"
                    class="checkbox-label"
                    v-if="
                      custom.displayTitles.indexOf(
                        settings[0].organizationId,
                      ) === -1
                    "
                    >{{ item.lastName
                    }}{{ item.firstName ? `, ${item.firstName}` : "" }}
                    <span v-if="item.sFirstName !== ''">&</span>
                    {{ item.sFirstName }}
                    <span v-if="item.sLastName !== item.lastName">
                      {{ item.sLastName }}
                    </span>
                    <span
                      v-if="
                        showPrices &&
                          item.price > 0 &&
                          organizationInfo.id !== 647
                      "
                      >{{ item.price | currency(settings[0].symbol) }}</span
                    ></label
                  >
                  <label
                    v-bind:for="item.id"
                    class="checkbox-label"
                    v-if="
                      custom.displayTitles.indexOf(settings[0].organizationId) >
                        -1 && item.sFirstName
                    "
                    >{{ item.lastName
                    }}{{ item.firstName ? `, ${item.firstName}` : "" }}
                    <span v-if="item.title !== ''">{{ item.title }}</span>
                    {{ item.sFirstName }}
                    <span v-if="item.sLastName !== item.lastName">
                      {{ item.sLastName }}
                    </span>
                    <span
                      v-if="
                        showPrices &&
                          item.price > 0 &&
                          organizationInfo.id !== 647
                      "
                      >{{ item.price | currency(settings[0].symbol) }}</span
                    ></label
                  >
                  <label
                    v-bind:for="item.id"
                    class="checkbox-label"
                    v-if="
                      custom.displayTitles.indexOf(settings[0].organizationId) >
                        -1 && !item.sFirstName
                    "
                  >
                    <span v-if="item.title !== ''">{{ item.title }}</span>
                    {{ item.lastName
                    }}{{ item.firstName ? `, ${item.firstName}` : "" }}
                    <span
                      v-if="
                        showPrices &&
                          item.price > 0 &&
                          organizationInfo.id !== 647
                      "
                      >{{ item.price | currency(settings[0].symbol) }}</span
                    >
                  </label>

                  <br />
                  <!-- <p>{{item.iSentLastYear}}/ {{item.sentToMeLastYear}}//{{item.reciprocal}}</p> -->
                  <span class="sub-label" v-if="settings[0].displayMisc2">{{
                    item.category
                  }}</span>
                  <!-- <span class="sub-label">{{item.mCategories}}</span> -->

                  <!--* only if  organizationInfo.id == 647--->

                  <span
                    class="btn-wrap"
                    style="display: block; width: 100%"
                    v-if="organizationInfo.id == 647"
                  >
                    <md-button
                      v-model="item.basketType"
                      v-bind:id="item.id"
                      class="btn-blue"
                      @click="handleItemSelection(item, 'Regular Baskets')"
                      v-bind:class="{
                        'btn-grey':
                          item.basketType !== 'Regular Baskets' ||
                          !item.selected,
                      }"
                      style="
                        color: white;
                        min-width: 80px !important;
                        height: 25px;
                        font-size: 12px;
                        min-height: 25px;
                      "
                      >Regular</md-button
                    >
                    <md-button
                      v-model="item.basketType"
                      v-bind:id="item.id"
                      class="btn-blue"
                      @click="handleItemSelection(item, 'Premium Baskets')"
                      v-bind:class="{
                        'btn-grey':
                          item.basketType !== 'Premium Baskets' ||
                          !item.selected,
                      }"
                      style="
                        color: white;
                        min-width: 80px !important;
                        height: 25px;
                        font-size: 12px;
                        min-height: 25px;
                      "
                      >Premium
                    </md-button>
                  </span>
                </div>
              </div>
              <!-- /.col-md-3 -->
            </div>
            <!-- /.row -->
          </div>
          <!-- /.boxes__content -->

          <div
            class="boxes__foot d-flex align-items-center flex-wrap"
            v-if="settings[0].displayLastYearsOrders"
          >
            <p>People I</p>

            <ul class="list-notes">
              <li>
                <span class="green"></span>

                <p>Sent</p>
              </li>

              <li>
                <span class="yellow"></span>

                <p>Reciprocated</p>
              </li>

              <li>
                <span class="blue"></span>

                <p>Received</p>
              </li>
            </ul>
            <!-- /.list-notes -->
          </div>
          <!-- /.boxes__foot -->

          <div class="boxes__notes d-flex justify-content-end flex-wrap">
            <p>
              Note: Your own name will not appear on this list because you
              cannot send to yourself.
            </p>

            <p class="red">
              <md-checkbox
                class="md-primary md-custom-paid md-checked"
                checked
                disabled
                >are orders already paid for</md-checkbox
              >
            </p>
            <!-- /.red -->
          </div>
          <!-- /.boxes__notes -->

          <div
            class="
              boxes__actions boxes__actions--mobile
              d-flex
              justify-content-lg-end justify-content-center
              flex-wrap
            "
          >
            <ul class="list-buttons list-buttons--mobile">
              <li>
                <md-button @click="restoreList()" class="btn-grey"
                  >Undo Changes</md-button
                >
              </li>

              <li>
                <md-button
                  @click="saveList(filteredData, promotions, false)"
                  class="btn-blue"
                  >Save for later</md-button
                >
              </li>
            </ul>
            <!-- /.list-buttons -->
            <md-button
              class="btn-green"
              @click="saveList(filteredData, promotions, true)"
              >Save & Continue</md-button
            >
          </div>
          <!-- /.boxes__actions -->
        </div>
        <!-- /.boxes -->
      </div>
      <!-- /.section__content -->
    </section>
    <!-- /.section-web -->
  </div>
  <!-- /.container container-/-large -->
</template>
<script>
import currencyFilter from "../shared/currency-filter";

export default {
  name: "ListPage",
  filters: {
    currency: currencyFilter,
  },
  data: function() {
    return {
      allPromotionChanged: false,
      changedPromotions: [],
      hidePaid: false,
      list: [],
      listCopy: [],
      search: "",
      showDialog: false,
      showPromotionsMobile: false,
      selFilter: 4,
      filterOptions: [
        { Label: "All", value: 4 },
        { Label: "People I sent to Last Year", value: 1 },
        { Label: "People I reciprocated to Last year", value: 2 },
        { Label: "People I received from Last Year", value: 3 },
      ],
      selCategory: 1,

      checkAll: false,

      sortOrder: false,
      sortOptions: [
        { Label: "A-Z", value: false },
        { Label: "Z-A", value: true },
      ],
      showDialogName: false,
      selNames: [],
    };
  },
  watch: {
    selNumber: async function(val) {
      ////console.log("val ", val);
      if (!val.length) {
        this.profile[0].reciprocity = false;
        await this.$store.dispatch("updateUserProfile", this.profile);
      }
    },
  },
  computed: {
    addOptions() {
      return this.$store.getters.addOptions;
    },
    selAmount() {
      let sum = 0;
      let arr = [];
      let data = this.filteredData;
      for (let i = 0; i < data.length; i++) {
        if (data[i].selected) {
          arr.push(data[i].price);
        }
      }
      if (arr.length) {
        sum = arr.reduce(function(a, b) {
          return a + b;
        });
      }
      //! TODO: turning into false for 647
      if (this.organizationInfo.id === 647 && sum < 100) {
        this.profile[0].reciprocity = false;
      }
      return sum;
    },
    showPrices() {
      return this.$store.state.showPrices;
    },
    profile() {
      let profile = this.$store.state.userProfile;
      if (profile[0].reciprocity === 1) {
        profile[0].reciprocity = true;
      }
      if (profile[0].reciprocity === 0) {
        profile[0].reciprocity = false;
      }
      return profile;
    },

    organizationInfo() {
      return this.$store.state.organizationInfo[0];
    },
    customOptions() {
      return this.$store.state.customOptions;
    },
    custom() {
      return this.$store.state.custom[0];
    },
    settings() {
      return this.$store.state.settings;
    },

    selNumber() {
      let obj = this.$store.state.list;
      let n = obj.filter((a) => a.selected && !a.paid);
      // console.log("n ", n);
      return n;
    },
    selNumberPaid() {
      let obj = this.$store.state.list;
      let n = obj.filter((a) => a.selected && a.paid);

      return n;
    },

    categories() {
      //console.log("this.$store.state.categories", this.$store.state.categories);
      let data = this.$store.state.categories;
      let prop = "sortOrder";
      data = data.sort(function(a, b) {
        return a[prop] > b[prop] ? 1 : b[prop] > a[prop] ? -1 : 0;
      });

      return data;
    },
    promotions() {
      // console.log({ pro: this.$store.state.promotions });

      let data = this.$store.state.promotions;
      let prop = "sortOrder";
      data = data.sort(function(a, b) {
        return a[prop] > b[prop] ? 1 : b[prop] > a[prop] ? -1 : 0;
      });
      return data;
    },
    promoNumber() {
      let n = [];
      let promos = this.$store.state.promotions;
      //console.log("promoss ", promos);
      for (let i = 0; i < promos.length; i++) {
        // console.log("promos[i].value", promos[i]);
        if (promos[i].value) {
          n.push(promos[i]);
        }
      }
      //console.log("n ", n);
      return n;
    },

    filteredData() {
      let obj = this.$store.state.list;
      let prop = "Name";

      if (Number(this.selCategory) !== 1) {
        obj = obj.filter(
          (data) => data.mCategories.indexOf(Number(this.selCategory)) !== -1,
        );
      }

      if (this.selFilter === 1) {
        obj = obj.filter(
          (data) =>
            (data.iSentLastYear === 1 &&
              data.reciprocal !== "Yes" &&
              data.sentToMeLastYear === 1) ||
            (data.iSentLastYear === 1 &&
              data.reciprocal !== "Yes" &&
              data.sentToMeLastYear === 0),
        );
      }
      if (this.selFilter === 3) {
        obj = obj.filter(
          (data) =>
            data.sentToMeLastYear === 1 &&
            data.reciprocal !== "Yes" &&
            !data.iSentLastYear,
        );
      }
      if (this.selFilter === 2) {
        obj = obj.filter((data) => data.reciprocal === "Yes");
      }
      if (this.hidePaid) {
        obj = obj.filter((data) => !data.paid);
      }
      obj = obj.filter(
        (data) =>
          data.lastName.toLowerCase().includes(this.search.toLowerCase()) ||
          data.firstName.toLowerCase().includes(this.search.toLowerCase()) ||
          data.sFirstName.toLowerCase().includes(this.search.toLowerCase()) ||
          data.sLastName.toLowerCase().includes(this.search.toLowerCase()),
      );
      //console.log("obj ", obj);

      if (!this.sortOrder) {
        obj = obj.sort(function(a, b) {
          return a[prop] > b[prop] ? 1 : b[prop] > a[prop] ? -1 : 0;
        });
      } else {
        obj = obj.sort(function(a, b) {
          return a[prop] > b[prop] ? 1 : b[prop] > a[prop] ? 0 : -1;
        });
      }

      return obj;
    },
  },
  methods: {
    handleItemSelection(item, type) {
      if (item.basketType === type) item.selected = !item.selected;
      else {
        item.basketType = type;
        item.selected = false;
        item.selected = true;
      }
    },
    listChanged: function() {
      this.$store.state.listChanged = true;
    },
    openPromotions: function() {
      this.selCategory = 1;
      this.search = "";
      this.selFilter = 4;
      // this.$store.dispatch("getPromotions");
      this.showDialog = true;
      let f_promo = this.promotions.filter(
        (a) =>
          !a.paid &&
          a.value &&
          (a.allCategories.indexOf("all") > -1 ||
            a.allCategories.indexOf("All") > -1 ||
            a.allCategories.indexOf("ALL") > -1),
      );
      if (f_promo.length) {
        this.onPromoChange(f_promo[0]);
      } else {
        for (let i = 0; i < this.promotions.length; i++) {
          if (!this.promotions[i].paid) {
            this.promotions[i].disabled = false;
          }
        }
      }
    },
    onPromoChange: function(item) {
      // this function is for checking of all promotion is selected and disable others that have no categories
      // console.log("promo ", item, "promotions ", this.promotions);
      if (
        item.allCategories.indexOf("all") > -1 ||
        item.allCategories.indexOf("ALL") > -1 ||
        item.allCategories.indexOf("All") > -1
      ) {
        this.allPromotionChanged = true;
        if (item.value) {
          for (let i = 0; i < this.promotions.length; i++) {
            if (
              this.promotions[i].allCategories.length &&
              this.promotions[i].itemId !== item.itemId &&
              !this.promotions[i].paid
            ) {
              this.promotions[i].value = false;
              this.promotions[i].disabled = true;
            }
          }
        } else {
          for (let i = 0; i < this.promotions.length; i++) {
            this.promotions[i].disabled = false;
          }
        }
      } else {
        if (this.changedPromotions.indexOf(item.id) === -1) {
          this.changedPromotions.push(item.id);
        }
        let f_promo = this.promotions.filter(
          (a) =>
            !a.paid &&
            a.value &&
            (a.allCategories.indexOf("all") > -1 ||
              a.allCategories.indexOf("All") > -1 ||
              a.allCategories.indexOf("ALL") > -1),
        );

        for (let i = 0; i < this.promotions.length; i++) {
          if (
            this.promotions[i].allCategories.length &&
            !this.promotions[i].paid &&
            !f_promo.length
          ) {
            this.promotions[i].disabled = false;
          }
        }
      }
    },
    setBasketType: function(item, type) {
      for (let i = 0; i < this.filteredData.length; i++) {
        if (this.filteredData[i].id === item.id) {
          this.filteredData[i].basketType = type;
          Vue.set(this.filteredData[i].basketType, type);

          // console.log(item, type, this.filteredData[i].basketType);
        }
      }
    },
    updateStoreList: function(data) {
      // let obj = this.$store.state.cart.list.filter(data=> data.id === data.id)
      // console.log("updaaating",data, obj)
    },
    openSelectedNames: function(d) {
      let data = this.$store.state.list;
      this.showDialogName = true;
      this.selNames = [];
      if (data.length) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].selected && !data[i].paid) {
            this.selNames.push(data[i]);
          }
        }
      }
    },
    selRecip: async function() {
      // this.$store.commit("updateReciprocity", val);
      // console.log("profile before ", this.profile);

      await this.$store.dispatch("updateUserProfile", this.profile);
    },
    checkAllPpl: function() {
      this.listChanged();
      if (!this.checkAll) {
        for (let i = 0; i < this.filteredData.length; i++) {
          if (!this.filteredData[i].paid) {
            this.filteredData[i].selected = false;
          }
        }
        //  i user unchecks all , promos should be cleared
        for (let i = 0; i < this.promotions.length; i++) {
          if (
            this.promotions[i].allCategories.length &&
            !this.promotions[i].paid
          ) {
            this.promotions[i].value = false;
          }
        }
      } else {
        for (let i = 0; i < this.filteredData.length; i++) {
          if (!this.filteredData[i].paid) {
            this.filteredData[i].selected = true;
          }
        }
      }
    },

    savePromotionsCheck(promo) {
      // console.log("zzzzzzzz", promo, this.promoNumber);
      //  if (this.promoNumber.length > 0) {

      // }
      let pr = false;
      for (let i = 0; i < this.promotions.length; i++) {
        if (this.promotions[i].value && !this.promotions[i].paid) {
          pr = true;
          break;
        }
      }
      if (!pr) {
        this.$store.commit("updateListInPromotions", []);
      }
      this.savePromotions(promo, true).then();
    },
    async savePromotions(promo, save) {
      try {
        let parsedpromo = JSON.parse(JSON.stringify(promo));

        // console.log("parsedpromo", parsedpromo, save);
        let combo = [];
        //   lets uncheck people first
        let false_promos = [];
        for (let i = 0; i < parsedpromo.length; i++) {
          if (!parsedpromo[i].value && parsedpromo[i].allCategories.length) {
            for (let z = 0; z < parsedpromo[i].allCategories.length; z++) {
              if (
                parsedpromo[i].allCategories[z].toLowerCase() === "all" &&
                this.allPromotionChanged
              ) {
                for (let k = 0; k < this.filteredData.length; k++) {
                  if (!this.filteredData[k].paid) {
                    this.filteredData[k].selected = false;
                  }
                }
                this.allPromotionChanged = false; // for promotion that has all, make sure if it is changed,only the we deselect
              } else {
                if (this.changedPromotions.indexOf(parsedpromo[i].id) > -1) {
                  for (let k = 0; k < this.filteredData.length; k++) {
                    //  if promotions categories have more than all category, loop through member categries and check if exsist, if yes select
                    if (
                      !this.filteredData[k].paid &&
                      this.filteredData[k].mCategories.indexOf(
                        Number(parsedpromo[i].allCategories[z]),
                      ) > -1
                    ) {
                      this.filteredData[k].selected = false;
                    }
                  }
                }
              }
            }
          }
        }

        //  if checked and  select based on categories
        for (let i = 0; i < parsedpromo.length; i++) {
          //  object to push to api
          let promo_obj = {
            promo: {},
            ids: [],
            members: [],
          };
          let obj = {
            itemId: parsedpromo[i].itemId,
            price: parsedpromo[i].price,
            quantity: 1,
            description: parsedpromo[i].displayText,
            shipTo: "",
            message: "",
          };

          if (parsedpromo[i].allCategories.length && parsedpromo[i].value) {
            promo_obj.promo = parsedpromo[i];
            for (let z = 0; z < parsedpromo[i].allCategories.length; z++) {
              if (
                parsedpromo[i].allCategories[z].toLowerCase() === "all" &&
                parsedpromo[i].value
              ) {
                //  if all category is select , select all pplz
                for (let d = 0; d < this.filteredData.length; d++) {
                  if (!this.filteredData[d].paid) {
                    this.filteredData[d].selected = true;
                    if (promo_obj.ids.indexOf(this.filteredData[d].id) === -1) {
                      promo_obj.ids.push(this.filteredData[d].id);
                      promo_obj.members.push(this.filteredData[d]);
                    }
                  }
                }
                combo.push(promo_obj);
              } else {
                for (let k = 0; k < this.filteredData.length; k++) {
                  //  if promotions categories have more than all category, loop through member categries and check if exsist, if yes select
                  if (
                    !this.filteredData[k].paid &&
                    this.filteredData[k].mCategories.indexOf(
                      Number(parsedpromo[i].allCategories[z]),
                    ) !== -1
                  ) {
                    this.filteredData[k].selected = true;
                    if (promo_obj.ids.indexOf(this.filteredData[k].id) === -1) {
                      promo_obj.ids.push(this.filteredData[k].id);
                      promo_obj.members.push(this.filteredData[k]);
                    }
                  }
                }
                let f = combo.filter((a) => a.promo.id === promo_obj.promo.id);
                if (!f.length) {
                  combo.push(promo_obj);
                }
              }
            }
          }
          // if send to all option selected
          if (save) {
            if (parsedpromo[i].value && !parsedpromo[i].paid) {
              await this.$store.dispatch("updateUpsell", {
                data: obj,
                param: "add",
              });
              this.$store.commit("updateListInPromotions", combo);
            } else {
              await this.$store.dispatch("updateUpsell", {
                data: obj,
                param: "delete",
              });
            }
          }
          this.changedPromotions = [];
        }
        ////console.log("promo combo ", combo);
      } catch (error) {
        console.error(error);
        showErrorAlert(true);
      }
    },
    async saveList(list, promo, redirect) {
      this.selCategory = 1;
      this.search = "";
      this.selFilter = 4;
      //just in case ppl dont check save promotions again
      for (let i = 0; i < this.promotions.length; i++) {
        if (this.promotions[i].value && !this.promotions[i].paid) {
          await this.savePromotions(promo, true);
          break;
        }
      }
      // reset to all, make sure all members are available and checked

      list = this.$store.state.list;
      let unchecked_arr = [];
      let checked_arr = [];
      let parsedlist = JSON.parse(JSON.stringify(list));
      let test = [];
      let checked_list = parsedlist.filter((a) => a.selected && !a.paid);
      let unchecked_list = parsedlist.filter((a) => !a.selected && !a.paid);

      this.$store.commit("addListToCart", checked_list);

      for (let i = 0; i < checked_list.length; i++) {
        let item = {};
        item.tempcode = this.$store.state.tempCode;
        item.receiver = checked_list[i].id;
        if (
          !this.$store.state.shippingCustomOptions.length ||
          this.customOptions.noShipCustom.indexOf(this.organizationInfo.id) > -1
        ) {
          item.price = checked_list[i].price;
        } else {
          let ship = this.$store.state.shippingCustomOptions.filter(
            (a) => a.description === checked_list[i].basketType,
          );

          if (ship.length) {
            item.price = ship[0].price;
            item.customPrice = ship[0].price;
          }
        }
        checked_arr.push(item);
      }
      for (let i = 0; i < unchecked_list.length; i++) {
        let item = {};
        item.tempCode = this.$store.state.tempcode;
        item.receiver = unchecked_list[i].id;
        item.price = unchecked_list[i].price;
        unchecked_arr.push(item);
      }

      if (checked_arr.length) {
        await this.$store.dispatch("updateData", {
          data: checked_arr,
          param: "add",
          redirect: redirect,
        });

        this.$store.state.checked_arr = checked_arr;
      }
      if (!checked_arr.length) {
        await this.$store.dispatch("updateData", { data: [], param: "clear" });
        if (redirect) {
          if (!this.addOptions) {
            this.$router.push("/content/payment").catch((error) => {
              if (error.name != "NavigationDuplicated") {
                throw error;
              }
            });
          } else {
            this.$router.push("/content/promo").catch((error) => {
              if (error.name != "NavigationDuplicated") {
                throw error;
              }
            });
          }
        }
      }
      await this.$store.dispatch("getTotal");
      await this.$store.dispatch("getOrderItems");
      this.$store.state.listChanged = false;
      localStorage.setItem("data", JSON.stringify(this.$store.state.list));
    },

    onCategoryChange: function(value) {
      this.checkAll = false;
    },
    sortData: function(data, prop, desc) {},
    restoreList: function() {
      let copyData = localStorage.getItem("data");
      let d = JSON.parse(copyData);
      for (let i = 0; i < d.length; i++) {
        for (let j = 0; j < this.filteredData.length; j++) {
          if (d[i].id === this.filteredData[j].id) {
            this.filteredData[j].selected = d[i].selected;
          }
        }
      }
    },
  },
  async created() {
    //console.log("List View Is Created ....");
    window.scrollTo(0, 0);
    await this.$store.dispatch("getPaymentMethods");
  },
  mounted() {
    //console.log("List View Is Mounted");
    this.list = this.$store.state.list;
    this.listCopy = this.list;
  },
  updated() {
    //console.log("List View is Updated");
    this.list = this.$store.state.list;
    this.listCopy = this.list;
  },
};
</script>
<style scoped>
.mb-2 {
  height: 55px;
  text-align: left;
}
.md-checkbox {
  /* width: 25px; */
  margin: 0;
}
.custom-checkbox--large {
  padding: 6px 5px 6px 15px;
}
.custom-control-check {
  position: relative;
  display: block;
  min-height: 1.5rem;
  padding-left: 0;
  min-width: 240px;
  text-align: left;
}
.md-checkbox .md-checkbox-label {
  height: 20px;
  padding-left: 16px;
  position: relative;
  line-height: 17px;
  min-width: 200px;
}
.checkbox-label {
  height: 20px;
  padding-left: 30px;
  position: relative;
  line-height: 17px;
  min-width: 200px;
  margin-bottom: 0;
}
.sub-label {
  font-size: 12px;
  color: grey;
  font-weight: 300;
}
.cust-check {
  width: 100%;
}
.search .search__btn {
  background-color: var(--app-color-primary);
  border-radius: 2px;
  padding: 4px 10px 3px;
  border: 0;
  /* min-height: 21px; */
  display: inline-block;
  border: 1px solid var(--app-color-primary);
}
.list-checks li + li {
  padding-left: 52px;
  margin-left: 52px;
  border-left: 0;
}
.promo-wrap {
  display: inline-block;
  width: 50%;
  padding: 0.5em;
}
.btn-green,
.btn-blue,
.btn-grey {
  text-transform: capitalize !important;
  min-width: 135px !important;
  min-height: 36px;
  padding: 0 8px !important;
}
.fa-question-circle {
  padding-left: 0.5em;
  font-size: 18px;
}
.custom-column {
  flex-direction: initial;
}
.custom-mb2 {
  min-height: 70px !important;
}
.custom-mb2 .custom-checkbox--large {
  padding: 8px 5px 6px 15px;
}
.md-button:visited {
  color: white !important ;
}
.md-button:focus {
  color: white !important ;
}
.md-ripple {
  color: white !important;
}
.section-web .section__note p {
  text-align: left;
}
.popup-names {
  overflow: auto;
  max-height: 400px;
  padding: 0.5em 2em !important;
}
.promo-wrap-wide {
  display: inline-block;
  width: 100%;
  padding: 0.5em;
}
.popup .popup__head {
  font-weight: 500;
}
.name-a {
  display: inline-block;
  vertical-align: middle;
  font-size: 17px;
  line-height: 1.06;
  letter-spacing: -0.01em;
  color: #3359d7;
  text-transform: uppercase;
  max-width: 80px;
  margin-bottom: 0;
}

@media (min-width: 1200px) {
  .col-xl-6 {
    flex: 0 0 70%;
    max-width: 70%;
  }
}
.list-checks-mobile li {
  text-align: left;
  padding: 1em;
}
.btn-grey-small {
  background-color: #c4c4c4;
  box-shadow: 2px 2px 5px 0px #c4c4c4;
  color: white !important;
  min-width: auto;
  height: 25px;
  margin: 6px 8px;
  padding: 0 1em;
  font-size: 13px;
}
.btn-blue-small {
  background-color: #5ea6f1;
  box-shadow: 2px 2px 5px 0px #5ea6f1;
  color: white !important;
  min-width: auto;
  height: 25px;
  margin: 6px 8px;
  padding: 0 1em;
  font-size: 13px;
}
.btn-green-small {
  background-color: #4bbe56;
  box-shadow: 2px 2px 5px 0px #5ef16b;
  color: white !important;
  min-width: auto;
  height: 25px;
  margin: 6px 8px;
  padding: 0 1em;
  font-size: 13px;
}
.list-tags li {
  width: auto;
}
.list-tags {
  border-bottom: 1px solid #ededed;
  padding-bottom: 1em;
}
.custom-checkbox--large {
  display: inline-block;
}
@media (max-width: 991px) {
  .boxes .boxes__actions--mobile {
    z-index: 10;
  }
}
.popup-names {
  max-height: 500px !important;
}
@media (max-width: 767px) {
  .list-buttons--mobile li {
    width: auto;
    display: inline-block;
  }
}

/* Hide the browser's default checkbox */
.list input {
  position: absolute;
  opacity: 1;
  cursor: pointer;
  height: 20px;
  width: 20px;
}

.select:before {
  z-index: 5;
  right: 11px;
  display: none;
  background-image: none;

  /* background-image: url(../assets/images/down.png);
  dis */
}
.select select {
  z-index: 4;
  background-color: transparent;
  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 1px;
  text-overflow: "";
}
.select:after {
  z-index: 3;

  background-repeat: no-repeat;
  background-size: cover;
  width: 30px;
}
.md-field.md-clearable .md-input {
  padding-right: 30px;
  font-size: 14px;
  letter-spacing: -0.01em;
  color: #b5b4b4;
  font-weight: 400;
  background-color: #fff;
  border: 1px solid #dedede;
  border-radius: 2px;
  padding: 4px 17px 3px;
  height: 28px;
}
.md-field:after,
.md-field:before {
  display: none;
}
.md-field {
  width: 100%;
  min-height: 28px;
  margin: 0;
  padding-top: 0;
  display: flex;
  position: relative;
  font-family: inherit;
}
.md-field .md-input-action {
  top: 0 !important;
  right: 4px;
  width: 20px;
  min-width: 20px;
}
.custom-checkbox-grey:after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: -1px;
  width: 5px;
  height: 100%;
  background-color: var(--app-color-primary) !important;
}
.btn--filter span {
  padding-right: 0 !important;
}
.popup__content {
  overflow: auto;
  max-height: 500px;
}
</style>
